import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-agreement',
  templateUrl: './user-agreement.component.html',
  styleUrls: ['./user-agreement.component.scss']
})
export class UserAgreementComponent implements OnInit {

  privacyPolicyUrl = '/#/privacy';
  constructor() { }

  ngOnInit(): void {
  }

}
